import { render, staticRenderFns } from "./copy-btn.vue?vue&type=template&id=e56e44ce&scoped=true&"
import script from "./copy-btn.vue?vue&type=script&lang=js&"
export * from "./copy-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56e44ce",
  null
  
)

export default component.exports